@if (campaign().merchant && campaign().merchant!.name && campaign().reward != undefined) {
  <div class="merchant-sentence-promo-title" *transloco="let t" [ngClass]="classes().container">
    <div class="row-container">
      <div class="text">{{ t('actions.card.sentence.earn') }}</div>
      <div class="chip" [ngClass]="classes().pill">{{ reward() }}</div>
    </div>
    <div class="row-container">
      <div class="text">{{ t('actions.card.sentence.for') }}</div>
      @if (cashbackFor()) {
        <div class="text">{{ t(cashbackFor()!) }}</div>
      }
      @switch (campaign().additionalConditions?.additionalConditionsType) {
        @case (AdditionalConditionsType.AMOUNT_SPENT) {
          <div class="text">
            {{ campaign().additionalConditions!.value! | loyaltyCurrency }}
          </div>
        }
        @case (AdditionalConditionsType.LOYALTY) {
          <lib-pill-loyalty [loyaltyScore]="campaign().additionalConditions!.value!"
                            [loyaltyLevel]="getLoyaltyLevel(campaign().additionalConditions!.value!)"
                            [highContrast]="highContrast()"
                            [size]="Size.SMALL">
          </lib-pill-loyalty>
        }
        @case (AdditionalConditionsType.NUMBER_OF_TRANSACTIONS) {
          <div class="text">
            {{ (campaign().additionalConditions!.value! | ordinalNumber) }} {{ t('actions.card.sentence.visits') }}
          </div>
        }
      }
    </div>
    <div class="row-container">
      <div class="text">{{ t('actions.card.sentence.at') }}</div>
      <div class="merchant-pill">
        <lib-pill-logo [companyName]="campaign().merchant?.name!"
                       [companyLogo]="campaign().merchant?.logoUrl!"
                       [color]="pillColor()"
                       [size]="Size.SMALL">
        </lib-pill-logo>
      </div>
    </div>
  </div>
}
